import { artifactPaneOf, type ArtifactPane } from "../../components/chat/artifact-registration";

/** The agent page keeps its open view in the address. */
export type AgentTab = "needs" | "commitments" | "files" | "settings";

export interface AgentPageSearch {
  readonly tab?: AgentTab;
  readonly revision?: string;
  readonly artifact?: string;
  readonly pane?: ArtifactPane;
  readonly compose?: string;
  /** The page kept in view beside the chat while the agent opens others. */
  readonly pinned?: string;
}

export function agentPageSearch(search: Record<string, unknown>): AgentPageSearch {
  const tab = search.tab === "needs" || search.tab === "commitments" || search.tab === "files" || search.tab === "settings" ? search.tab : undefined;
  return {
    ...(tab === undefined ? {} : { tab }),
    ...(typeof search.revision === "string" && /^[1-9][0-9]{0,18}$/.test(search.revision) ? { revision: search.revision } : {}),
    ...(typeof search.artifact === "string" && search.artifact.length <= 500 ? { artifact: search.artifact } : {}),
    ...(typeof search.compose === "string" && search.compose.length <= 200 ? { compose: search.compose } : {}),
    ...(typeof search.pinned === "string" && search.pinned.length <= 500 ? { pinned: search.pinned } : {}),
    ...(artifactPaneOf(search.pane) ? { pane: artifactPaneOf(search.pane) } : {}),
  };
}

/** The lead agent's conversation keeps which of its conversations is open (`?chat=`): on
 *  Operation, Team and Board alike. */
export interface LeadSearch extends AgentPageSearch {
  readonly chat?: string;
}

export function leadSearch(search: Record<string, unknown>): LeadSearch {
  return {
    ...(typeof search.chat === "string" && /^[0-9a-f-]{36}$/.test(search.chat) ? { chat: search.chat } : {}),
    ...agentPageSearch(search),
  };
}
